/**
 * Created by jonathan.kernick on 06/09/2016.
 */
var JumpGame = function (gameEndFunc, characterNum, backgroundNum, difficultyNum, json, audioJson) {
    PIXI.Container.call(this);
    this.json = json;
    this.audioJson = audioJson;
    this.characterNum = characterNum || 0;
    this.backgroundNum = backgroundNum || 0;
    this.difficultyNum = difficultyNum || 0;
    this.gameEndFunc = gameEndFunc;
    this.score = 0;
    this.distance = 0;
    this.platformCount = 100;
    this.platformGenOffset = -600;
    this.platformPool = [];
    this.collectibleCount = 100;
    this.collectiblePool = [];
    this.pointsPool = [];
    this.pointsCount = 10;
    this.currentPlatformGenHeight = 0;
    this.gravity = 1200;
    this.jumpVelocity = -1200;
    this.controlSpeed = 150;
    this.controlVelocity = 0;
    this.controlVelocityGamma = 0;
    this.playerVelocity = 0;
    this.dropLimit = 0;
    this.player = Widgets.createAsset(this.json.characters[this.characterNum]);
    this.hitLayer = new PIXI.Container();
    this.cameraContainer = new PIXI.Container();
    this.cameraTarget = new PIXI.Point(0, 0);
    this.platformContainer = new PIXI.Container();
    this.collectibleContainer = new PIXI.Container();
    this.pointsContainer = new PIXI.Container();
    this.leftKeyDown = false;
    this.rightKeyDown = false;
    this.score = 0;
    this.playing = false;
    this.scoreText = new PIXI.extras.BitmapText("1", {
        font: this.json.score_text.textSize + "px VAGRoundedBig",
        tint:  this.json.score_text.tint
    });
    this.scoreTextShadow = new PIXI.extras.BitmapText("1", {
        font: this.json.score_text.textSize + "px VAGRoundedBig",
        tint: 0x0
    });
    this.scoreTextShadow.alpha = 0.25;
    this.scoreIcon = Widgets.createAsset(this.json.score_text.asset);
    this.playerWidthBounds = 640;
    //modify for different backgrounds
    this.baseBackground = Widgets.createBackgroundAsset(json.backgrounds[this.backgroundNum]);
    var tileBackgroundJson = json.tileBackgrounds[this.backgroundNum];
    this.tileBackground = CC.Utility.pixiAtlasTilingSprite(tileBackgroundJson.texture, 640, 3000);
    this.tileBackground.tileHeight = this.tileBackground.texture.frame.height;
    this.colourBackground = new PIXI.Graphics();
    this.colourBackground.beginFill(tileBackgroundJson.colour);
    this.colourBackground.drawRect(-320, -568, 640, 1136);
    this.colourBackground.endFill();
    window.jsonTest = this.json;
    this.collectableRangesEasy = [];
    this.collectableRangesHard = [];
    this.platformsRangesEasy = [];
    this.platformsRangesHard = [];
    this.leaningEaseOff = 1;

    this.mouseX = 0;


    this.build();
};

JumpGame.prototype = Object.create(PIXI.Container.prototype);
JumpGame.prototype.constructor = JumpGame;

JumpGame.prototype.build = function () {
    //declare vars
    var i, self, platform, collectible, points;

    this.addChild(this.colourBackground);
    this.addChild(this.tileBackground);
    this.addChild(this.baseBackground);

    //for scope breaking
    self = this;
    //create keyboard events
    if (!CC.isMobile) {
        var targetWindow = window.parent || window;
        this.keyboardControlEventDown = targetWindow.addEventListener("keydown", this._keyDown.bind(this));
        this.keyboardControlEventUp = targetWindow.addEventListener("keyup", this._keyUp.bind(this));
    }
    else {
        var targetWindow = window.top;
        this.orientationControlEvent = targetWindow.addEventListener('deviceorientation', function (event) {
            self.controlVelocityGamma = event.gamma;
        });
    }
    //populate platformPool and collectiblePool;
    for (i = 0; i < this.collectibleCount; ++i) {
        collectible = new JumpGameCollectible(this.json.collectibles);
        this.collectiblePool.push(collectible);
        this.collectibleContainer.addChild(collectible);
    }
    for (i = 0; i < this.platformCount; ++i) {
        platform = new JumpGamePlatform(this.json.platforms);
        this.platformPool.push(platform);
        this.platformContainer.addChild(platform);
    }
    for (i = 0; i < this.pointsCount; ++i) {
        points = new JumpGamePoints(this.json.item_score_text);
        this.pointsPool.push(points);
        this.pointsContainer.addChild(points);
    }

    for (i = 0; i < this.json.collectibles.length; ++i) {
        this.collectableRangesEasy.push(this.json.collectibles[i].easyFreq);
        this.collectableRangesHard.push(this.json.collectibles[i].hardFreq);
    }
    for (i = 0; i < this.json.platforms.length; ++i) {
        this.platformsRangesEasy.push(this.json.platforms[i].easyFreq);
        this.platformsRangesHard.push(this.json.platforms[i].hardFreq);
    }


    //position ui
    this.scoreIcon.anchor.x = 0;
    this.scoreIcon.anchor.y = 0;
    this.scoreIcon.x = -300;
    this.scoreText.x = this.scoreIcon.x + this.scoreIcon.width+5;
    this.scoreTextShadow.x = this.scoreIcon.x + this.scoreIcon.width + 4 + 5;

    this.hitLayer.interactive = true;
    this.hitLayer.hitArea = new PIXI.Rectangle(-1000, -1000, 2000, 2000);

    this.hitLayer.mousedown = this.hitLayer.touchstart = function (event) {
        this.grabbed = true;
        self.mouseX = event.data.getLocalPosition(this).x;
    };
    this.hitLayer.mousemove = this.hitLayer.touchmove = function (event) {
        if (this.grabbed) {
            self.mouseX = event.data.getLocalPosition(this).x;
        }
    };
    this.hitLayer.mouseup = this.hitLayer.touchend = this.hitLayer.mouseupoutside = this.hitLayer.touchendoutside = function (event) {

        this.grabbed = false;
        self.leftKeyDown = false;
        self.rightKeyDown = false;
    };


    //build display tree;
    this.cameraContainer.addChild(this.platformContainer);
    this.cameraContainer.addChild(this.collectibleContainer);
    this.cameraContainer.addChild(this.player);
    this.cameraContainer.addChild(this.pointsContainer);


    this.addChild(this.cameraContainer);
    this.addChild(this.hitLayer);
    this.addChild(this.scoreTextShadow);
    this.addChild(this.scoreText);
    this.addChild(this.scoreIcon);


};
JumpGame.prototype.proabilityCheck = function (ranges) {
    var i, range, index, length, total, value;
    length = ranges.length;
    total = 0;
    for (i = 0; i < length; ++i) {
        total += ranges[i];
    }
    value = Math.random() * total;
    range = 0;
    for (i = 0; i < length; ++i) {
        range += ranges[i];
        if (value < range) {
            index = i;
            i = length;
        }
    }
    return index;
};
JumpGame.prototype.unbuild = function () {
    if (!CC.isMobile) {
        var targetWindow = window.parent || window;
        targetWindow.removeEventListener("keydown", this.keyboardControlEventDown);
        targetWindow.removeEventListener("keyup", this.keyboardControlEventUp);
    }
    else {
        document.removeEventListener('deviceorientation', this.orientationControlEvent);
    }
};
JumpGame.prototype.genPlatform = function (first) {
    var xPosition = (Math.random() - 0.5) * 400 * (!first);
    var yPosition = this.currentPlatformGenHeight - 100;
    if (this.lastPlatform) {
        yPosition = this.currentPlatformGenHeight - this.lastPlatform.nextPlatformDistance;
    }

    var collectable;
    var addCollectibleBool = Math.random() > 0.7;
    if (addCollectibleBool) {
        collectable = this.addCollectible(xPosition, yPosition - 70, 0);
    }
    var type;
    if(first){
        type = 0;
    }else{
        if (!!this.difficultyNum) {
            type = this.proabilityCheck(this.platformsRangesHard);
        }
        else {
            type = this.proabilityCheck(this.platformsRangesEasy);
        }
    }
    this.lastPlatform = this.addPlatform(xPosition, yPosition, type);
    if(this.lastPlatform.destroyable && collectable){
        collectable.hide();
    }
    // this.lastPlatform.collectable = collectable;
    // this.lastPlatformBouncy = type === 1;
    this.currentPlatformGenHeight = yPosition;
};
JumpGame.prototype._keyDown = function (event) {
    switch (event.keyCode) {
        case 37://left
            event.preventDefault();
            this.leftKeyDown = true;
            break;
        case 39://right
            event.preventDefault();
            this.rightKeyDown = true;
            break;
    }

};
JumpGame.prototype._keyUp = function (event) {
    switch (event.keyCode) {
        case 37://left
            event.preventDefault();
            this.leftKeyDown = false;
            break;
        case 39://right
            event.preventDefault();
            this.rightKeyDown = false;
            break;
    }

};
JumpGame.prototype.start = function () {
    this.currentPlatformGenHeight = 200;
    this.playing = true;
    for (var i = 0; i < 3; ++i) {
        this.genPlatform(!i);
    }
};
JumpGame.prototype.pause = function () {

};
JumpGame.prototype.addPlatform = function (x, y, type) {
    //find a free platform ie one that is not currently visible
    var i, platform, length;
    length = this.platformCount;
    for (i = 0; i < length; ++i) {
        platform = this.platformPool[i];
        if (!platform.visible) {
            i = length;
        }
    }
    if (platform) {
        platform.show(x, y, type);
    }
    return platform;
};
JumpGame.prototype.addCollectible = function (x, y) {
    //find a free platform ie one that is not currently visible
    var i, collectible, length, type;
    length = this.collectibleCount;
    for (i = 0; i < length; ++i) {
        collectible = this.collectiblePool[i];
        if (!collectible.visible) {
            i = length;
        }
    }
    if (collectible) {
        if (!!this.difficultyNum) {

            type = this.proabilityCheck(this.collectableRangesHard);
        }
        else {
            type = this.proabilityCheck(this.collectableRangesEasy);
        }
        collectible.show(x, y, type);
    }
    return collectible;
};
JumpGame.prototype.showPoints = function (x, y, score) {
    this.score += score;
    this.scoreText.text = "" + this.score;
    this.scoreTextShadow.text = "" + this.score;

    //find a free points ie one that is not currently visible
    var i, points, length;
    length = this.pointsCount;
    for (i = 0; i < length; ++i) {
        points = this.pointsPool[i];
        if (!points.visible) {
            i = length;
        }
    }
    if (points) {
        points.show(x, y, score);
    }
};
JumpGame.prototype.end = function () {
    this.unbuild();
    this.gameEndFunc(this.score);
};
JumpGame.prototype.update = function (delta) {
    var i, self, platform, collectible, distance;


    if (this.hitLayer.grabbed) {
        if (this.mouseX - this.player.x < 0) {
            this.rightKeyDown = false;
            this.leftKeyDown = true;
        }
        else {

            this.leftKeyDown = false;
            this.rightKeyDown = true;
        }
    }


    this.scoreIcon.y = CC.WebApp.current.screenHeight * -0.5 +10;
    this.scoreText.y =  this.scoreIcon.y + this.scoreIcon.height*0.5 - 50

    this.scoreTextShadow.y = this.scoreText.y + 4;
    //going left;
    if (this.leftKeyDown && !this.rightKeyDown) {
        this.leaningEaseOff = 0;
        //this.player.x -= this.controlSpeed * delta;
        this.controlVelocity -= this.controlSpeed * delta * 10;
        this.player.scale.x = 1;
    }
    //going right
    if (this.rightKeyDown && !this.leftKeyDown) {
        this.leaningEaseOff = 0;
        //this.player.x += this.controlSpeed * delta;
        this.controlVelocity += this.controlSpeed * delta * 10;
        this.player.scale.x = -1;
    }
    if (CC.isMobile && !this.rightKeyDown && !this.leftKeyDown) {
        this.leaningEaseOff = Math.min(this.leaningEaseOff += delta, 1);
        this.controlVelocity = this.controlVelocityGamma * delta * 1000 * this.leaningEaseOff;
        if (Math.abs(this.controlVelocity) > 10) {
            if (this.controlVelocity > 0) {

                this.player.scale.x = -1;
            }
            else {
                this.player.scale.x = 1;

            }
        }
    }
    this.playerVelocity += this.gravity * delta;
    this.player.oldy = this.player.y;
    this.controlVelocity *= 0.95;
    this.player.x += this.controlVelocity * delta;
    this.player.y += this.playerVelocity * delta;
    this.player.x = Math.max(this.player.x, this.playerWidthBounds * -0.5);
    this.player.x = Math.min(this.player.x, this.playerWidthBounds * 0.5);
    for (i = 0; i < this.platformCount; ++i) {
        platform = this.platformPool[i];
        //check if the platform is visible and has been hit;
        if (platform.visible) {
            if (platform.checkHit(this.player)) {
                //to keep things fair set the player height to the platform
                this.player.y = platform.y;
                if (!platform.used) {
                    this.showPoints(platform.x, platform.y, 10);
                }
                this.playerVelocity = platform.jumpVelocity;
                sound.play(this.audioJson.jump);

                //bump the platform
                this.dropLimit = Math.min(this.dropLimit, platform.y);
                platform.hit();
            }
            //if the platform is out of sight remove it;
            if (platform.y > this.dropLimit + CC.WebApp.current.screenHeight * 0.5 + 100) {
                platform.hide();
            }
        }
    }
    for (i = 0; i < this.collectibleCount; ++i) {
        collectible = this.collectiblePool[i];
        //check if the collectable is visible and has been hit;
        if (collectible.visible) {
            if (collectible.checkHit(this.player)) {
                collectible.collect();
                this.showPoints(collectible.x, collectible.y, collectible.points);
                sound.play(this.audioJson.collect);
            }
            //if the collectable is out of sight remove it;
            if (collectible.y > this.player.y + 1000) {
                collectible.hide();
            }
        }
    }
//keep adding platforms untill you are far enough away from the player
    while (this.playing && this.currentPlatformGenHeight > this.player.y + this.platformGenOffset) {
        this.genPlatform();
    }
//detect player death
    if (this.player.y > this.dropLimit + CC.WebApp.current.screenHeight * 0.5 + 300) {
        this.end();
    }
    //camera movement
    this.cameraTarget.y = Math.min(this.player.y, this.cameraTarget.y);
    this.cameraContainer.y = Math.lerp(-this.cameraTarget.y, this.cameraContainer.y, 0.9);
    this.baseBackground.y = this.cameraContainer.y * 0.2;
    this.tileBackground.y = this.baseBackground.y % this.tileBackground.tileHeight;
    this.tileBackground.y -= 568
};


var JumpGamePlatform = function (platformsArray) {
    PIXI.Container.call(this);
    this.jumpVelocity = -100;
    this.platformsArray = platformsArray;
    this.platformWidth = this.platformsArray[0].width;
    this.visible = false;
    this.enabled = false;
    this.used = false;
    this.graphic = CC.Utility.pixiSprite(this.platformsArray[0].texture);
    this.type = 0;
    this.addChild(this.graphic);
};

JumpGamePlatform.prototype = Object.create(PIXI.Container.prototype);
JumpGamePlatform.prototype.constructor = JumpGamePlatform;

JumpGamePlatform.prototype.hide = function () {
    this.visible = false;
    this.enabled = false;
    this.graphic.y = 0;
    this.graphic.alpha = 1;
};
JumpGamePlatform.prototype.checkHit = function (player) {
    var hitBool = player.oldy < this.y && player.y >= this.y;
    if (hitBool) {
        hitBool = Math.abs(this.x - player.x) < this.platformWidth * 0.5;
    }
    if (hitBool) {
        hitBool = this.worldTransform.ty < CC.WebApp.current.screenHeight
    }
    return hitBool && this.enabled;
};
JumpGamePlatform.prototype.hit = function () {
    this.used = true;
    if (this.destroyable) {
        this.enabled = false;
        TweenLite.to(this.graphic, 0.5, {alpha: 0});
        TweenLite.to(this.graphic, 0.5, {y: 100, onComplete: this.hide.bind(this)});
        //TweenLite.to(this.graphic.scale, 0.2, {x: 1.5, y: 1.5});
    }
    else {
        this.graphic.scale.x = 1.1;
        this.graphic.scale.y = 0.9;
        this.graphic.y = 10;
        TweenLite.to(this.graphic, 0.5, {ease: Back.easeOut, y: 0});
        TweenLite.to(this.graphic.scale, 0.5, {x: 1, y: 1, ease: Back.easeOut});
    }
};
JumpGamePlatform.prototype.show = function (x, y, type) {
    TweenLite.killTweensOf(this.graphic);
    this.type = type || 0;
    var obj = this.platformsArray[this.type];
    this.jumpVelocity = obj.jumpVelocity;
    this.nextPlatformDistance = obj.nextPlatformDistance;
    // this.platformWidth = obj.width;
    this.destroyable = !!obj.destroyable;
    this.enabled = true;
    this.used = false;
    this.graphic.alpha = 1;
    this.graphic.scale.x = 1;
    this.graphic.scale.y = 1;
    this.graphic.texture = PIXI.Texture.fromFrame(obj.texture);
    this.platformWidth = this.graphic.width;
    this.visible = true;
    this.x = x;
    this.y = y;
};

var JumpGameCollectible = function (collectiblesArray) {
    PIXI.Container.call(this);
    this.collectiblesArray = collectiblesArray;
    this.visible = false;
    this.enable = false;
    this.points = 0;
    this.graphic = CC.Utility.pixiSprite(this.collectiblesArray[0].texture);
    this.addChild(this.graphic);
};

JumpGameCollectible.prototype = Object.create(PIXI.Container.prototype);
JumpGameCollectible.prototype.constructor = JumpGameCollectible;

JumpGameCollectible.prototype.checkHit = function (player) {
    var testDistance = CC.Geometry.vectorDistanceSquared(player, this);
    return testDistance < 50 * 50 && this.enable;
};
JumpGameCollectible.prototype.collect = function () {
    this.enable = false;
    TweenLite.to(this.graphic, 0.2, {alpha: 0});
    TweenLite.to(this.graphic.scale, 0.2, {x: 2, y: 2, onComplete: this.hide.bind(this)});
};
JumpGameCollectible.prototype.show = function (x, y, type) {
    TweenLite.killTweensOf(this.graphic);
    this.type = type || 0;
    this.graphic.alpha = 1;
    this.enable = true;
    this.graphic.scale.x = 1;
    this.graphic.scale.y = 1;
    this.points = this.collectiblesArray[this.type].points;
    this.graphic.texture = PIXI.Texture.fromFrame(this.collectiblesArray[this.type].texture);
    if(this.sparkles){
        this.removeChild(this.sparkles);
    }
    if(this.collectiblesArray[this.type].sparkles){
        this.sparkles = Widgets.createAsset(this.collectiblesArray[this.type].sparkles);
        this.addChild(this.sparkles);
        this.sparkles.gotoAndPlay(0);
    }
    this.visible = true;
    this.x = x;
    this.y = y;
};
JumpGameCollectible.prototype.hide = function () {
    this.graphic.alpha = 1;
    this.visible = false;
    this.enable = false;
};

var JumpGamePoints = function (textJson) {
    PIXI.Container.call(this);
    this.visible = false;
    this.text = new PIXI.extras.BitmapText("1", {font: textJson.textSize+"px VAGRounded",tint:textJson.tint});
    this.addChild(this.text);
};

JumpGamePoints.prototype = Object.create(PIXI.Container.prototype);
JumpGamePoints.prototype.constructor = JumpGamePoints;

JumpGamePoints.prototype.show = function (x, y, score) {

    this.text.alpha = 1;
    this.text.text = score;
    this.text.x = this.text.width * -0.5;
    this.text.y = 0;
    this.visible = true;
    this.x = x;
    this.y = y;
    TweenLite.to(this.text, 0.7, {alpha: 0, y: -100, onComplete: this.hide.bind(this)});
};
JumpGamePoints.prototype.hide = function () {
    this.text.alpha = 1;
    this.visible = false;
};

